import apiClient, { API_BASE_URL } from './api-client';

export const API = API_BASE_URL;
export const HTTP = apiClient;

export default apiClient;
